import { useState } from "react";

const useWorldMap = (initialProps = {}) => {
  const [stateWorldMap, setState] = useState({
    members: [],
    loading: true,
    error: null,
    highlightedCountries: [],
    selectedCountry: null,
    selectedCountryName: null,
    selectedMembers: [],
    isModalOpen: false,
    hoveredCountry: null,
    mapCenter: [0, 20], // Map center coordinates [longitude, latitude]
    mapZoom: 1, // Map zoom level
    geographies: [], // Loaded geography data for bounds calculation
  });

  const setWorldMap = (field, value) => {
    if (typeof field === "object") {
      setState((prevState) => ({ ...prevState, ...field }));
    } else {
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const toggleWorldMapField = (field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return {
    stateWorldMap,
    setWorldMap,
    toggleWorldMapField,
  };
};

export default useWorldMap;
